import { AutoFocus } from 'primeng/autofocus';

let applied = false;

/**
 * PrimeNG 21 hands each component's `autofocus` input to its AutoFocus directive, and that input is
 * `undefined` unless a template sets it. AutoFocus only removes the HTML `autofocus` attribute for
 * `false`: for `undefined` it writes `autofocus="true"`, so every select, date picker, button… carries
 * the attribute, and on each page load the browser focuses the first one. A date picker then opens
 * its calendar and the page scrolls to it. 21.1.10 is the last free release, so the fix lives here:
 * an unset input means no autofocus. Called once, before the app boots.
 */
export function fixPrimeNgAutofocus(): void {
    if (applied) {
        return;
    }
    applied = true;
    const original = AutoFocus.prototype.onAfterContentChecked;
    AutoFocus.prototype.onAfterContentChecked = function (this: AutoFocus): void {
        this.autofocus ??= false;
        original.call(this);
    };
}
